import { render, staticRenderFns } from "./Scroll2Top.vue?vue&type=template&id=c7a2246c&scoped=true&"
import script from "./Scroll2Top.vue?vue&type=script&lang=js&"
export * from "./Scroll2Top.vue?vue&type=script&lang=js&"
import style0 from "./Scroll2Top.vue?vue&type=style&index=0&id=c7a2246c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a2246c",
  null
  
)

export default component.exports